export default __webpack_public_path__ + "static/media/36.01433196.png";